/**
 * home/data/homeStats.ts
 * Estadísticas del Hero y constantes de configuración
 *
 * DATOS VERIFICADOS contra código real (auditoría 2026-03-01):
 * - 62 formatos: coordinateNormalizer + parsers/
 * - 116 patrones UTF-8: 111 mojibake (37+41+33) + 5 charNormalizer — VERIFICADO, se mantiene
 * - 7,4M+ refs: CDAU 3,2M + Catastro 2,4M + NGA 1,8M
 * - 785 municipios: INE Andalucía (correcto)
 */
import type { StatItem } from './types';

export const AUTH_KEY      = 'ptel_authenticated';
export const AUTH_USER_KEY = 'ptel_user';
export const AUTH_DATE_KEY = 'ptel_auth_date';
export const THEME_KEY     = 'ptel_theme';
export const VALID_USERS   = ['BOC', 'BOR', 'BLI'] as const;

export const LOG_API_URL =
  'https://script.google.com/macros/s/AKfycbxJ5vKbdZu2g6ILThWvvhJMGJYqFQ50CaUozp4UkQCBxPBauMmehNrcd8LZlyU5oW8/exec';

// PORT 26-ago · `OBS-P1-PORTADA-ANUNCIA-NUEVE-Y-ADMITE-CUATRO-SIN-PARSER`.
// Aquí vivían `ACCEPTED_FORMATS` y `FORMAT_TAGS`, ambas con los 9 formatos
// históricos (DBF, GeoJSON, KML y TSV incluidos), que `documentExtractor` no
// sabe parsear. La portada los anunciaba y los admitía, y el rechazo llegaba
// después de que la interfaz hubiera dicho dos veces que el fichero valía.
// La fuente única es `src/lib/acceptedFormats.ts`: consúmela desde allí
// (`ACCEPT_ATTR` para el `accept=`, `FORMAT_TAGS` para los chips). No volver a
// declarar la lista aquí — la corrección de S1-b ya llegó al wizard y no a la
// portada precisamente por estar duplicada.

export const STATS: readonly StatItem[] = [
  { value: '62',   label: 'Formatos coord.' },
  { value: '116',  label: 'Patrones UTF-8'  },
  { value: '7,4M+', label: 'Referencias'   },
  { value: '785',  label: 'Municipios'      },
] as const;
